import React from 'react';
import { Svg, ISvg } from '../../Svg';

export const RunPreview: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 24 24" fill="none" {...props}>
    <rect width="24" height="24" transform="translate(0.5 0.5)" />
    <path
      d="M17.8 10.4407C19.4 11.3559 19.4 13.6441 17.8 14.5593L10.6 18.6779C9 19.5931 7 18.4491 7 16.6186L7 8.38141C7 6.55093 9 5.40688 10.6 6.32212L17.8 10.4407Z"
      fill="#212133"
    />
  </Svg>
);
